import { Routes } from '@angular/router';
import { canActivateAuthRole } from './guards/auth.guard';
import { UserListComponent } from '@app/features/users/components/user-list/user-list.component';
import { AddUserComponent } from '@app/features/users/components/add-user/add-user.component';
import { userResolver } from './features/users/resolvers/user-details.resolver';
import { EventListComponent } from './features/events/components/event-list/event-list.component';
import { AddEventComponent } from './features/events/components/add-event/add-event.component';
import { GroupListComponent } from './features/groups/components/group-list/group-list.component';
import { AddGroupComponent } from './features/groups/components/add-group/add-group.component';
import { MessageListComponent } from './features/messages/components/message-list/message-list.component';
import { AuthorizedEntityListComponent } from './features/authorized-entity/components/authorized-entity-list/authorized-entity-list.component';
import { AddAuthorizedEntityComponent } from './features/authorized-entity/components/add-authorized-entity/add-authorized-entity.component';
import { AddAuthorizedPersonComponent } from './features/authorized-entity/components/add-authorized-person/add-authorized-person.component';
import { HelpComponent } from './features/help/components/help/help.component';
import { LinkAccountComponent } from './features/authorized-entity/components/link-account/link-account.component';
import { DashboardComponent } from './features/home/components/dashboard/dashboard.components';
import { authorizedEntityResolver } from './features/authorized-entity/resolvers/authorized-entity.resolver';

export const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full'
  },
  {
    path: 'events',
    component: EventListComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full'
  },
  {
    path: 'events/add',
    component: AddEventComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full'
  },
  {
    path: 'events/edit/:id',
    component: AddEventComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full',
  },
  {
    path: 'users',
    component: UserListComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full',
  },
  {
    path: 'users/add',
    component: AddUserComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full',

  },
  {
    path: 'users/edit/:userName',
    component: AddUserComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full',
    resolve: {
      user: userResolver
    }
  },
  {
    path: 'authorized-entity',
    component: AuthorizedEntityListComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full'
  },
  {
    path: 'authorized-entity/add',
    component: AddAuthorizedEntityComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full'
  },
  {
    path: 'authorized-entity/edit/:uuid',
    component: AddAuthorizedEntityComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full',
    resolve: {
      authorizedEntity: authorizedEntityResolver
    }
  },
  {
    path: 'authorized-entity/:id/add-person',
    component: AddAuthorizedPersonComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full'
  },
  {
    path: 'authorized-entity/:id/edit-person/:personId',
    component: AddAuthorizedPersonComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full'
  },
  {
    path: 'authorized-entity/:id/persons/:personId/assing',
    component: LinkAccountComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full'
  },
  {
    path: 'groups',
    component: GroupListComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full'
  },
  {
    path: 'groups/add',
    component: AddGroupComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full'
  },
  {
    path: 'groups/edit/:id',
    component: AddGroupComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full'
  },
  {
    path: 'messages',
    component: MessageListComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full'
  },
  {
    path: 'help',
    component: HelpComponent,
    canActivate: [canActivateAuthRole],
    pathMatch: 'full'
  }
];
